import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

const particleOptions = {
  fullScreen: { enable: false },
  background: { color: "transparent" },
  fpsLimit: 60,
  particles: {
    number: { value: 50 },
    opacity: { value: 0.7 },
    size: { value: 2 },
    move: { enable: true, speed: 0.5, direction: "none", random: false },
  },
  detectRetina: true,
};

const StarsBackground = () => (
  <Particles
    id="tsparticles"
    init={async (engine) => {
      await loadSlim(engine);
    }}
    options={particleOptions}
    className="absolute inset-0 h-full w-full pointer-events-none"
  />
);

export default StarsBackground;